import React, { useState, useEffect } from 'react';
import {IProps} from './types';
import * as S from './styles';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { storageAccountName, containerNameBrands } from '@storage/azure-storage-blob';
import { handleImageError, handleBrandImageLoad } from '@utils/brand';
import { IBrandImage } from '@state/brandsImages/types';
import DragElement from '../../DragElement';
import _ from 'lodash';

const uuid = require('react-uuid');

const SearchList:React.FC<IProps> = (props) => {
  const [imagesList, setImagesList] = useState<IBrandImage[]>([]);

  const urlBrand =`https://${storageAccountName}.blob.core.windows.net/${containerNameBrands}`;

  useEffect(() => {        
    if(props.imagesList?.length>0) setImagesList(_.cloneDeep(props.imagesList));
  }, [props.imagesList]);

  const getImageSrc = (data:IBrandImage)=>{
    if (data.id=="" || data.id== undefined) return data.srcImage;
    else return `${urlBrand}/${data.brandId}/${data.imageType?data.imageType.toLowerCase():""}/${data.srcImage}` + "TN";
  }

  const handleOnSelect = async(imageInfo: any) => props.onSelect(imageInfo);
  
  return (
    <S.Root>
      <S.SectionContainer>
        <TransitionGroup className="group-list">
          { imagesList.map((imageInfo: any, index: number) => {
              return (
                <CSSTransition key={imageInfo.id} timeout={1} classNames="item">
                  <DragElement
                    key={index}
                    id={imageInfo.id}
                    type="Image"
                    itemData={imageInfo}
                    style={{padding: `0px 5px 0px 5px`}}
                  >
                      <S.ItemContainer 
                        id={`preview-component-${index}0`}
                        selected={false}
                        onClick={(e) => {handleOnSelect(imageInfo)}}
                      >
                        <S.ImgContainer
                          width={imageInfo.width}
                          height={imageInfo.height}
                          src={getImageSrc(imageInfo)} 
                          transparent={imageInfo.type==="Jellybean"}       
                          onLoad={(e) => setImagesList(handleBrandImageLoad(e, imageInfo.id, imagesList))}
                          onError={() => setImagesList(handleImageError(imageInfo.id, imagesList))}
                        />
                      </S.ItemContainer>
                  </DragElement>
                </CSSTransition>
              )
            })
          }
        </TransitionGroup>
      </S.SectionContainer>        
    </S.Root>

  );
}

export default SearchList;